import { type FC } from 'react';

import { cn } from '@/lib/utils';

import Step from './components/Step';
import { setProperStepStatus } from './utils/setProperStepStatus';
import type { StepperProps } from './Stepper.types';

const Stepper: FC<StepperProps> = ({
    stepsNumber,
    activeStep,
    className,
    ...props
}) => (
    <ul
        className={cn('flex w-full', className)}
        {...props}
    >
        {[...Array(stepsNumber)].map((_, i) => (
            <Step
                key={i}
                status={setProperStepStatus(i + 1, activeStep)}
                stepNumber={i + 1}
            />
        ))}
    </ul>
);

export default Stepper;
